import React from 'react';
import PropTypes from 'prop-types';
import { ContextMenu, Button, Dropdown } from '@weezevent/nacre';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SubscriptionPlanModel from '../../../models/subscriptionPlanModel';

function MembershipPrimaryCTA({ organization, membership }) {
    const history = useHistory();
    const { t } = useTranslation();
    return (
        <Button
            style={{ width: '100%' }}
            primary
            label={t('ticket.membership.list.create_membership')}
            onClick={() => history.push(`/ticket/O${organization.id}/memberships/${membership.id}`)}
        />
    );
}

export default function MembershipContextMenu({ organization, membership }) {
    const { t } = useTranslation();
    const history = useHistory();

    const [plans] = SubscriptionPlanModel.useApiModel({ organizationId: organization.id }, [organization]);

    const switchProps = React.useMemo(() => {
        return {
            switchMenuProps: {
                text: t('ticket.membership.list.title'),
                items: (plans ?? []).map(m => (
                    <Dropdown.Item key={m.id} onClick={() => history.push(`/ticket/O${organization.id}/memberships/${m.id}`)}>
                        {m.name}
                    </Dropdown.Item>
                ))
            }
        };
    }, [plans, organization, history, t]);

    return (
        <ContextMenu
            cta={<MembershipPrimaryCTA organization={organization} membership={membership} />}
            title={membership.name}
            catchphrase={t('ticket.membership.list.title')}
            {...switchProps}
        />
    );
}

MembershipContextMenu.propTypes = {
    organization: PropTypes.object.isRequired,
    membership: PropTypes.object.isRequired
};
